import React, {useEffect, useState} from "react";
import {DATA_FETCHGING_STATUSES, ROUTES, WIDGET_DISPLAY_TYPES} from "../utils/constants";

const FILES = {
  bmtc: ["agency.txt", "calendar.txt", "feed_info.txt", "routes.txt", "stop_times.txt", "stops.txt", "trips.txt"],
  bmrcl: ["agency.txt", "calendar.txt", "calendar_dates.txt", "fare_attributes.txt", "fare_rules.txt", "feed_info.txt", "routes.txt", "shapes.txt", "stop_times.txt", "stops.txt", "transfers.txt", "translations.txt", "trips.txt"]
};

const DataWidget = ({ defaultDisplay, files, lastUpdated, type, showToggle = false }) => {
  const [displayType, setDisplayType] = useState(defaultDisplay || WIDGET_DISPLAY_TYPES.table);
  const [dataType, steDataType] = useState("bmtc");
  const [selectedFile, setSelectedFile] = useState("trips.txt");
  const [data, setData] = useState([]);
  const [dataHeaders, setDataHeaders] = useState([]);
  const [dataStatus, setDataStatus] = useState(DATA_FETCHGING_STATUSES.ERROR);
  const [fetchAttemptCount, setFetchAttemptCount] = useState(0);

  const filesList = showToggle ? FILES[dataType] : files;

  useEffect(() => {
    const getData = async () => {
      try {
        setDataStatus(DATA_FETCHGING_STATUSES.PROGRESS);
        const dynamicData = await fetch(`/${type || dataType}/${selectedFile}`, { cache: 'no-store' });
        const dataString = await dynamicData.text();
        const [headers, ...dataArray] = dataString.split("\n");
        setDataHeaders(headers.split(","));
        setData(dataArray.map(d => d.split(",")));
        setDataStatus(DATA_FETCHGING_STATUSES.SUCCESS);
      } catch {
        setDataStatus(DATA_FETCHGING_STATUSES.ERROR);
      }
    }
    getData();
  }, [selectedFile, fetchAttemptCount, dataType]);
  return (
    <>
      <div className="widget-header no-mobile">
        {
          showToggle && (
            ["bmtc", "bmrcl"].map(display => (
              <button
                className={`widget-type-btn ${display === dataType ? "selected" : ""}`}
                key={display}
                onClick={() => steDataType(display)}
              >{display}</button>
            ))
          )
        }
        {
          displayType === WIDGET_DISPLAY_TYPES.table && (
            <div className="widget-select-wrapper">
              <select className="widget-file-select" value={selectedFile} onChange={e => setSelectedFile(e.target.value)}>
                {
                  filesList.map(f => <option key={f}>{f}</option>)
                }
              </select>
            </div>
          )
        }
        <p>
          {lastUpdated}
        </p>
      </div>
      <div className="widget-content no-mobile">
        {
          dataStatus === DATA_FETCHGING_STATUSES.PROGRESS && (
            <div className="widget-nonsuccess">
              <div className="loader" />
              Fetching file: {selectedFile}
            </div>
          )
        }
        {
          dataStatus === DATA_FETCHGING_STATUSES.ERROR && (
            <div className="widget-nonsuccess">
              <p>
                Error fetching file: {selectedFile}<br/><br/>
                <button href={ROUTES.gtfs} className="btn-link" onClick={() => setFetchAttemptCount(fetchAttemptCount + 1)}>
                  Try again
                </button>
              </p>
            </div>
          )
        }
        {
          dataStatus === DATA_FETCHGING_STATUSES.SUCCESS && (
            <table className="widget-table" cellSpacing={0}>
              <thead>
              <tr>
                { dataHeaders.map(h => <th key={h}>{h}</th>)}
              </tr>
              </thead>
              <tbody>
              { data.map((d, index) => <tr key={index}>
                {
                  d.map((ditem, ditemindex) => <td key={ditemindex}>{ditem}</td>)
                }
              </tr>)}
              </tbody>
            </table>
          )
        }
      </div>
    </>
  );
};

export default DataWidget;
